export function generateReferralUrl(url: string) {
  const urlObj = new URL(url);
  urlObj.searchParams.set('xaff', 'Relume');
  return urlObj.toString();
}
